export default __webpack_public_path__ + "static/media/loyalty_logo.cdc7d007.svg";